import { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { getTokenSilent } from '../libs/auth';
import { msalInstance } from '../libs/auth/msalInstance';

export const ACCESS_TOKEN_LOCAL_STORAGE_KEY = 'accessToken';
export const ID_TOKEN_LOCAL_STORAGE_KEY = 'idToken';

export const getIdTokenFromStorage = () => localStorage.getItem(ID_TOKEN_LOCAL_STORAGE_KEY);

let isLoggingOut = false;

export const setup401Interceptor = (client: AxiosInstance) => {
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401 && !isLoggingOut) {
        isLoggingOut = true;
        const accounts = msalInstance.getAllAccounts();
        msalInstance
          .logoutRedirect({
            account: accounts[0] ?? undefined,
            postLogoutRedirectUri: `${process.env.REACT_APP_MSAL_REDIRECT_URI}?sessionExpired=true`
          })
          .catch(console.error);
      }
      return Promise.reject(error);
    }
  );
};

export const injectIdToken = async (
  config: InternalAxiosRequestConfig
): Promise<InternalAxiosRequestConfig> => {
  const tokenResponse = await getTokenSilent();

  if (tokenResponse && config.headers) {
    config.headers.Authorization = `Bearer ${tokenResponse.idToken}`;
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
    }
  }
  return config;
};
